const CLARITY_SCRIPT_ID = 'microsoft-clarity';

export function getClarityProjectId(): string | undefined {
  return import.meta.env.VITE_CLARITY_PROJECT_ID || undefined;
}

export function injectClarity(projectId: string): void {
  if (document.getElementById(CLARITY_SCRIPT_ID)) return;

  const script = document.createElement('script');
  script.id = CLARITY_SCRIPT_ID;
  script.type = 'text/javascript';
  script.textContent = `
    (function(c,l,a,r,i,t,y){
      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window,document,"clarity","script","${projectId}");
  `;
  document.head.appendChild(script);
}

export function removeClarityScript(): void {
  const script = document.getElementById(CLARITY_SCRIPT_ID);
  if (script) script.remove();

  if ('clarity' in window) {
    delete (window as Record<string, unknown>).clarity;
  }
}
